'use strict';

module.exports = ['Activity Space', 'Bar/Pub', 'Boat', 'Brewery', 'Cocktail Bar', 'Country Club', 'Cultural Venue', 'Event Space', 'Home', 'Hotel', 'Loft', 'Lounge', 'Meeting Space', 'Nightclub', 'Private or Membership Venue', 'Residential Venue', 'Restaurant', 'Rooftop', 'Vineyard', 'Wine Bar'];